module.exports = __webpack_public_path__ + "assets/img/modal-avatar-2da89265.png";